import { axios } from '@/utils/request'

const api = {
    analysisIndexData: '/adminapi/analysis/indexdata',
    noticeData: '/adminapi/analysis/noticeData',
    analysisOrderIndexData: '/adminapi/analysis/analysisOrderIndexData',


}

export default api

export function analysisIndexData(parameter) {
    return axios({
        url: api.analysisIndexData,
        method: 'get',
        params: parameter
    })
}
export function noticeData(parameter) {
    return axios({
        url: api.noticeData,
        method: 'get',
        params: parameter
    })
}

export function analysisOrderIndexData(parameter) {
    return axios({
        url: api.analysisOrderIndexData,
        method: 'get',
        params: parameter
    })
}